import { call, put, takeEvery } from 'redux-saga/effects';
import { browserHistory } from 'react-router';
import { push } from 'react-router-redux';

import * as clevertapForgot from 'mf-shared/clevertap/forgot';
import * as apiForgotPassword from '../../api/forgotPassword';
import * as auth from '../../api/auth';
import * as apiUsers from '../../api/users';
import {
  SEND_PASSWORD_OTP_REQUEST,
  VERIFY_PASSWORD_OTP,
  GENERATE_PASSWORD_OTP,
} from './types';
import { FORGOT_PASSWORD } from '../constant-mess';
import * as forgotPasswordAction from './actions';
import {
  sendingRequest,
  showProgressBar,
  hideProgressBar,
} from '../moka/actions';
import * as actionNotification from '../notifications/actions';
import { resetGoBizPasswordSuccess } from '../resetGoBizPassword/actions';

export function* forgotPasswordFlow(request) {
  yield put(sendingRequest(true));
  yield put(showProgressBar());
  const { email, captcha } = request.payload.data;
  try {
    if (isNaN(email)) {
      const { data } = yield call(auth.registered, email);
      if (data.present) {
        yield call(apiUsers.forgotPassword, { email, captcha });
        yield put(forgotPasswordAction.passwordChangeBy('email'));
        browserHistory.push('/success-forgot-password');
      } else {
        yield put(actionNotification.error('Email does not exist'));
      }
    } else {
      const phone = `+62${email}`;
      const { data } = yield call(auth.validatePhone, phone);
      if (data.status === 'Invalid') {
        yield put(forgotPasswordAction.sendPasswordOtpRequest({ phone }));
      } else {
        yield put(actionNotification.error('Phone number does not exist'));
      }
    }
  } catch (error) {
    yield put(actionNotification.error(error.message));
  } finally {
    yield put(hideProgressBar());
    yield put(sendingRequest(false));
  }
  clevertapForgot.forgotPasswordStart({
    email,
  });
}

export function* otpRequestFlow(request) {
  yield put(sendingRequest(true));
  yield put(showProgressBar());
  const { phone } = request.payload.data;
  try {
    const { data } = yield call(apiForgotPassword.generateOtp, phone);
    if (!data.error && data.status_code === 0) {
      const { request_id, token } = data;
      if (request_id || token) {
        yield put(forgotPasswordAction.showOtp(true));
        yield put(forgotPasswordAction.setPasswordOtpRequestId(request_id));
        yield put(forgotPasswordAction.setPasswordToken(token));
      } else {
        yield put(resetGoBizPasswordSuccess());
        yield put(push('/reset-gobiz-password-done'));
      }
    } else {
      yield put(actionNotification.error(data.reason));
    }
  } catch (error) {
    yield put(actionNotification.error(error.message));
  } finally {
    yield put(hideProgressBar());
    yield put(sendingRequest(false));
  }
}

export function* verifyPasswordOtpSaga({ payload }) {
  yield put(sendingRequest(true));
  yield put(showProgressBar());
  const { code, request_id: requestId, token } = payload.data;
  yield put(forgotPasswordAction.otpError(null));
  try {
    const { data } = yield call(apiForgotPassword.verfyPasswordOtp, {
      request_id: requestId,
      code,
    });
    if (data.status_code) {
      yield put(forgotPasswordAction.otpError(data.status));
    } else {
      yield put(forgotPasswordAction.otpError(null));
      browserHistory.push(`/reset-password/${token}`);
    }
  } catch (error) {
    if (error.response.data.status_code) {
      yield put(forgotPasswordAction.otpError(error.response.data.status));
    } else {
      yield put(actionNotification.error('Network Error'));
    }
  } finally {
    yield put(hideProgressBar());
    yield put(sendingRequest(false));
  }
}

export function* resendOtpSaga(action) {
  yield put(sendingRequest(true));
  yield put(showProgressBar());
  const { phone } = action.payload.data;
  try {
    const response = yield call(apiForgotPassword.generateOtp, phone);
    if (response.data.status) {
      const { request_id } = response.data;
      yield put(forgotPasswordAction.setPasswordOtpRequestId(request_id));
      yield put(forgotPasswordAction.setPasswordToken(response.data.token));
    }
  } catch (error) {
    yield put(actionNotification.error(error.message));
  } finally {
    yield put(hideProgressBar());
    yield put(sendingRequest(false));
  }
}

export default function* saga() {
  yield takeEvery(FORGOT_PASSWORD, forgotPasswordFlow);
  yield takeEvery(SEND_PASSWORD_OTP_REQUEST, otpRequestFlow);
  // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
  yield takeEvery(VERIFY_PASSWORD_OTP, verifyPasswordOtpSaga);
  yield takeEvery(GENERATE_PASSWORD_OTP, resendOtpSaga);
}
